import { GroupByMode, newTaskSuffix } from '@griply/types';
import { getNewTaskPrefill } from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';
import { LifeArea } from 'shared/types/life-area';

import { GoalHeader } from '../goal-header';
import { LifeAreaHeader } from '../life-area-header';
import { TreeTaskCard } from '../tree-task-card';
import { useLifeAreaRenderData } from './life-area-render-context';

export const LifeAreaRenderItem: React.FC<RenderItemProps> = ({
  item,
  itemInstance,
  tree,
  isMultiSelectModifierPressed,
}) => {
  const {
    groupSettings,
    tasksMap,
    tasks,
    lifeAreasMap,
    lifeAreas,
    links,
    goals,
    today,
    denseFormat,
    defaultNewTaskDate,
  } = useLifeAreaRenderData();

  const type = item.type;

  if (type === TaskListItemTypes.Task) {
    const task = tasksMap[item.sourceId];
    if (!task) {
      return null;
    }
    return (
      <TreeTaskCard
        task={task}
        tree={tree}
        item={itemInstance}
        tasks={tasks}
        isMultiSelectModifierPressed={isMultiSelectModifierPressed}
        hideLifeArea
        displayDue={groupSettings.displayDue}
      />
    );
  }

  if (type === TaskListItemTypes.NewTask) {
    const groupSectionId = item.sourceId.replace(newTaskSuffix, '');
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.LifeArea,
      groupSectionId,
      groupSetting: groupSettings,
      today,
      defaultNewTaskDate,
    });
    return (
      <NewTaskRow
        lifeArea={prefill.lifeAreaId}
        date={prefill.startDate}
        startTime={null}
        duration={null}
        tags={prefill.tagIds}
      />
    );
  }

  if (type === TaskListItemTypes.LifeArea) {
    const lifeArea: LifeArea | undefined = lifeAreasMap[item.sourceId];
    return (
      <LifeAreaHeader
        item={itemInstance}
        lifeArea={lifeArea}
        denseFormat={denseFormat}
      />
    );
  }

  if (type === TaskListItemTypes.Goal) {
    return (
      <GoalHeader
        item={itemInstance}
        goals={goals}
        lifeAreas={lifeAreas}
        links={links}
        denseFormat={denseFormat}
      />
    );
  }

  return null;
};
